import { createFileRoute, redirect } from "@tanstack/react-router";

// `/admin/integrations/{kind}` opens that card's drawer on Integrations (spec 2.5). The Microsoft
// 365 admin-consent return lands here with `?email_consent=`, which the page turns into a toast.
export const Route = createFileRoute("/admin/integrations/$kind")({
  beforeLoad: ({ params, search }) => {
    const consent = (search as Record<string, unknown>).email_consent;
    throw redirect({
      to: "/admin/integrations",
      search: {
        open: params.kind,
        ...(typeof consent === "string" ? { email_consent: consent as never } : {}),
      },
      replace: true,
    });
  },
});
